<div [class]="customClass" [matTooltip]="isTextOverflowing(primaryTextRef) || isTextOverflowing(secondaryTextRef) ? tooltipTextValue : undefined"
        matTooltipClass="award-history-custom-tooltip" matTooltipPosition="after">
    <ng-container *ngIf="columnType === awardHistoryModalCellRedererType.AWARD">
        <img class="mr-1" [src]="'../Admin/ImageResizer.aspx?imgid=' + awardHistoryItem.BadgeID + '&w=28&h=28'"
            width="28" height="28" />
    </ng-container>
    <ng-container *ngIf="columnType === awardHistoryModalCellRedererType.COINS">
        <svg class="award-history-coin-icon mr-1" style="width: 19.24px !important;height:19.24px !important;">
            <use href="../App_Themes/CXone/icons/gamification/coin.svg#coin"></use>
        </svg>
    </ng-container>
    <span #primaryTextRef class="history-modal__normal-text text-truncate">{{primaryText}}</span>
    <span #secondaryTextRef class="history-modal__gray-text text-truncate">{{secondaryText}}</span>
</div>